import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { CarEventTabView } from './car-event-tab-view';
import { getEventDataSelector, getIsEventDataLoadingSelector } from '../../selectors';

const CarEventTabWrapper = ({ eventData, isEventDataLoading }) => {
	return <CarEventTabView eventData={eventData} isEventDataLoading={isEventDataLoading} />;
};

CarEventTabWrapper.propTypes = {
	eventData: PropTypes.string,
	isEventDataLoading: PropTypes.bool.isRequired,
};

const mapStateToProps = createStructuredSelector({
	eventData: getEventDataSelector(),
	isEventDataLoading: getIsEventDataLoadingSelector(),
});

const CarEventTab = connect(mapStateToProps)(CarEventTabWrapper);

export { CarEventTab };
